import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=89a6d76c&"
import script from "./Stats?vue&type=script&lang=js&"
export * from "./Stats?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports